import { AssetType } from '@ardoq/api-types';

export type AssetTypeLabels = Record<AssetType, string>;

export const DEFAULT_ASSET_TYPE_LABELS: AssetTypeLabels = {
  [AssetType.BOOKMARK]: 'Bookmark',
  [AssetType.TRAVERSAL]: 'Viewpoint',
  [AssetType.FOLDER]: 'Folder',
  [AssetType.WORKSPACE]: 'Workspace',
  [AssetType.PRESENTATION]: 'Presentation',
  [AssetType.SURVEY]: 'Survey',
  [AssetType.METAMODEL]: 'Metamodel',
  [AssetType.SCENARIO]: 'Scenario',
  [AssetType.REPORT]: 'Report',
  [AssetType.DASHBOARD]: 'Dashboard',
  [AssetType.BROADCAST]: 'Broadcast',
  [AssetType.VIEWPOINT]: 'Discover viewpoint',
};

const getAssetTypeDisplayName = (
  assetType: AssetType,
  labels: AssetTypeLabels = DEFAULT_ASSET_TYPE_LABELS
): string => {
  return labels[assetType] || assetType;
};

const getAllPossibleAssetTypes = (): AssetType[] => {
  return Object.keys(DEFAULT_ASSET_TYPE_LABELS) as AssetType[];
};

export const assetTypeOperations = {
  getAssetTypeDisplayName,
  getAllPossibleAssetTypes,
};
